import { mapGetters } from 'vuex'

export default {
  ...mapGetters('app/patient/agendas', [
    'filters'
  ])
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/schedule/resources/computed.js